import { useEffect, useMemo, useState } from "react";
import { postAxios } from "../../util/apiCall";
import moment from "moment";
import * as XLSX from "xlsx";

export const useInventory = () => {
  const dataAuth = localStorage.getItem("auth");
  const dataUser = JSON.parse(dataAuth);

  const [menu, setMenu] = useState("inventory");
  const [dataListBarang, setDataListBarang] = useState();
  const [searchBarang, setSearchBarang] = useState("");

  const [popUpTambahStock, setPopUpTambahStock] = useState(false);
  const [popUpKurangStock, setPopUpKurangStock] = useState(false);

  const [jumlahTambah, setJumlahTambah] = useState();
  const [dataPick, setDataPick] = useState();

  const [popUpDetail, setPopUpDetail] = useState(false);
  const [dataDetail, setDetail] = useState();

  const [refresh, setRefresh] = useState(false);

  const [dataList, setDataList] = useState();
  const [popUpTambahInventory, setPopUpTambahInventory] = useState(false);
  const [searchListPopUp, setSearchListPopUp] = useState("");
  const [keteranganTambahKurang, setKeteranganTambahKurang] = useState("");

  const [filterFrom, setFilterFrom] = useState();
  const [filterUntil, setFilterUntil] = useState();

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getInventory`,
      {
        tim: dataUser.tim,
      },
      dataUser.auth,
      setDataListBarang,
      ""
    );
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getListNamaBpb`,
      {
        tim: dataUser.tim,
      },
      dataUser.auth,
      setDataList,
      ""
    );
    setRefresh(false);
  }, [refresh]);

  const dataTempSearch = useMemo(() => {
    const list = dataListBarang?.listNamaBarang || [];
    if (!searchBarang) return list;
    const q = searchBarang.toLowerCase();
    return list.filter((v) => v?.value?.toString().toLowerCase().includes(q));
  }, [dataListBarang, searchBarang]);

  const handlePickData = (data) => {
    setDataPick(data);
  };

  const handleTambahStock = () => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/tambahStock`,
      {
        tim: dataUser.tim,
        id: dataPick.id,
        jumlah: jumlahTambah ? Number(jumlahTambah) : 0,
        updatedBy: dataUser.name,
        keterangan: keteranganTambahKurang,
        type: popUpTambahStock ? "Tambah" : "Kurang",
      },
      dataUser.auth,
      "",
      ""
    );
    setTimeout(() => {
      setJumlahTambah();
      setDataPick();
      setPopUpTambahStock(false);
      setPopUpKurangStock(false);
      setRefresh(true);
      setKeteranganTambahKurang();
    }, 200);
  };

  const handleCloseDetail = () => {
    setPopUpDetail(false);
    setDataPick();
    setDetail();
    setFilterFrom();
    setFilterUntil();
  };

  const handlePickDetail = (data) => {
    setPopUpDetail(true);
    setDataPick(data);

    const finalFilterFrom =
      filterFrom ||
      moment().utcOffset(7).startOf("month").format("YYYY-MM-DDTHH:mm:ssZ");

    const finalFilterUntil =
      filterUntil ||
      moment().utcOffset(7).endOf("month").format("YYYY-MM-DDTHH:mm:ssZ");

    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getDetailBpb`,
      {
        tim: dataUser.tim,
        id: data?.id,
        filterFrom: finalFilterFrom,
        filterUntil: finalFilterUntil,
      },
      dataUser.auth,
      setDetail,
      ""
    );
  };

  useEffect(() => {
    if (dataPick?.id) {
      handlePickDetail(dataPick);
    }
  }, [filterFrom, filterUntil]);

  const dataTempSearchList = useMemo(() => {
    const list = dataList?.listNamaBarang || [];
    if (!searchListPopUp) return list;
    const q = searchListPopUp.toLowerCase();
    return list.filter((v) => v?.value?.toString().toLowerCase().includes(q));
  }, [dataList, searchListPopUp]);

  const handleChangeChecklist = (id, event) => {
    const updatedList = dataList.listNamaBarang.map((item) => {
      if (item.id === id) {
        return {
          ...item,
          [event.target.name]: event.target.checked,
          [`isEdit`]: true,
        };
      }
      return item;
    });

    setDataList({
      ...dataList,
      listNamaBarang: updatedList,
    });
  };

  const handleTambahInventory = () => {
    const results = dataTempSearchList.filter((item) => item.isEdit);

    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/setDataToInventory`,
      {
        tim: dataUser.tim,
        data: results,
      },
      dataUser.auth,
      "",
      ""
    );

    setTimeout(() => {
      setPopUpTambahInventory(false);
      setRefresh(true);
    }, 200);
  };

  const handleExportStock = async () => {
    try {
      let data = dataListBarang?.listNamaBarang || [];

      const filteredDataExcel = await data.map((obj, index) => {
        return {
          "No.": index + 1,
          "Nama Barang": obj.label,
          Jumlah: obj.jumlah,
          "Last Update": obj.updateTime
            ? moment(obj.updateTime).format("DD-MM-YY, HH:mm:ss")
            : "",
          "Updated By": obj.updatedBy,
        };
      });

      const workSheet = XLSX.utils.json_to_sheet(
        filteredDataExcel && filteredDataExcel
      );

      workSheet["!cols"] = [
        { wch: 4 },
        { wch: 51 },
        { wch: 8 },
        { wch: 17 },
        { wch: 20 },
      ];
      const workBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workBook, workSheet, "Barang Jadi");
      XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
      XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
      XLSX.writeFile(workBook, `Stock Barang Purchasing.xlsx`);
    } catch (error) {
      console.log(error);
    }
  };

  return {
    dataUser,
    menu,
    setMenu,
    dataTempSearch,
    searchBarang,
    setSearchBarang,
    popUpTambahStock,
    setPopUpTambahStock,
    jumlahTambah,
    setJumlahTambah,
    handlePickData,
    handleTambahStock,
    popUpDetail,
    handlePickDetail,
    dataDetail,
    dataPick,
    handleCloseDetail,
    setRefresh,
    popUpTambahInventory,
    setPopUpTambahInventory,

    searchListPopUp,
    setSearchListPopUp,
    dataTempSearchList,
    handleChangeChecklist,
    handleTambahInventory,
    keteranganTambahKurang,
    setKeteranganTambahKurang,
    popUpKurangStock,
    setPopUpKurangStock,
    filterFrom,
    setFilterFrom,
    filterUntil,
    setFilterUntil,
    handleExportStock,
  };
};
